import styled, {css} from 'styled-components';
import {GroupProps, GroupVariant} from './types';

export const Wrapper = styled.div<
  Pick<GroupProps, 'variant'>
>`
  row-gap: 14px;
  grid-template-rows: auto 1fr;
  display: grid;
  min-height: 240px;
  padding: 14px;
  box-sizing: border-box;
  border-radius: 5px;
  
  ${({variant, theme}) => {
    switch (variant) {
      case GroupVariant.Default: return css`
        background: ${theme.variables.backgroundColor};
      `;
      case GroupVariant.Empty: return css`
        
      `;
    }
  }};
`;

export const Title = styled.span`
  line-height: 18px;
  font-weight: 500;
  font-size: 14px;
`;

export const Words = styled.div`
  
`;
